import { useQuery } from '@tanstack/react-query';

import { getStripeConnections } from '../api/status';
import type { StripeConnectionsResponse } from '../types';

export function useStripeConnections(orgId: number | string | undefined) {
  return useQuery<StripeConnectionsResponse>({
    queryKey: ['stripeConnections', orgId],
    queryFn: () => {
      if (!orgId) {
        throw new Error('orgId is required');
      }
      return getStripeConnections(orgId);
    },
    enabled: !!orgId,
    // Poll while any connection is syncing. We deliberately do NOT stop on
    // error: React Query keeps the last successful `data` during a transient
    // fetch failure, so a syncing connection keeps polling and recovers on its
    // own. Polling stops only once nothing is syncing (or no data has loaded).
    refetchInterval: query => {
      const { data } = query.state;
      return data?.connections?.some(c => c.connection_status === 'syncing')
        ? 5000
        : false;
    },
  });
}
